export const ApiRoutes = {
  GetRsvps: "/rsvps",
  CreateRsvp: "/rsvp",
  UpdateRsvp: "/rsvp",
  GetRsvpDetails: "/rsvp",
  GetStartingPoints: "/starting-points",
};
